import React, { useState } from 'react'
import Mensagem from './Mensagem'
import { obterPorProtocolo } from '../services/DenunciaServico'
import { InputGroup, FormControl, Button } from "react-bootstrap";

export default function Protocolo(props) {

    const [numeroProtocolo, setNumeroProtocolo] = useState('')
    const [mensagem, setMensagem] = useState('') 

    const buscaPeloProtocolo = () => {
        setMensagem({ tipo:'LIMPAR', texto:'' })
        props.setShowSpinner(true)
        props.setAnonimato("")
        obterPorProtocolo(numeroProtocolo)
        .then( resposta => {
            props.setCorrespondenciaEntregue({ ...props.correspondenciaEntregue, protocolo: numeroProtocolo })
            props.showFormulario('Narrativa')
            props.setChamador('Protocolo')
            props.setComplementacao(numeroProtocolo)
            props.setShowSpinner(false)
        })
        .catch( msgErroDenuncia => {
            setMensagem(msgErroDenuncia)
            props.setShowSpinner(false)
        })
    }

    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "protocolo") {
        return null;
    }

    return(
        <>
            <Mensagem mensagem={ mensagem } />
            <fieldset className="border p-4 mt-4">
                <InputGroup>
                    <FormControl 
                        id="idFormDenunciaBuscaPeloProtocolo"
                        name="buscapeloprotocolo"
                        type="text" 
                        placeholder="Digite o número do Protocolo" 
                        className="mr-sm-2"
                        value={ numeroProtocolo }
                        onChange={ event => setNumeroProtocolo(event.target.value) }
                    />
                    <Button variant="outline-primary" onClick={ buscaPeloProtocolo }>Buscar denúncia</Button>
                </InputGroup>
            </fieldset>
        </>
    )
}